import React, { useState } from "react";
import { FaExchangeAlt } from "react-icons/fa";
import { Popover } from "antd";
import ChangeOrderRowTemplate from "./ChangeOrderRowTemplate";

export default function ChangeOrderRowPopover({
  item_id,
  item_product_name,
  item_product_price,
  item_quantity,
  order_id,
  updateOrderRowGoods,
  showRemove
}) {
  const [show_popover, set_show_popover] = useState(false);
  return (
    <Popover
      placement="left"
      title={"Replace the product"}
      //
      visible={show_popover}
      onVisibleChange={(loading) => set_show_popover(loading)}
      content={
        show_popover ? (
          <ChangeOrderRowTemplate
            item_id={item_id}
            item_product_name={item_product_name}
            item_product_price={item_product_price}
            item_quantity={item_quantity}
            order_id={order_id}
            updateOrderRowGoods={updateOrderRowGoods}
            onClose={() => set_show_popover(false)}
          />
        ) : (
          ""
        )
      }
      trigger="click"
    >
      <FaExchangeAlt
        className="text-info cursor-pointer"
        style={{
          visibility: showRemove ? "visible" : "hidden",
          marginLeft: "10px",
        }}
      />
    </Popover>
  );
}
